
import http from '../httpService';

export function GetLastExpiringMeasures() {
  return http.get(`/measures/last-expiring-measures/10?size=4`);
}
